const state = {
  user: null,
  isLoginShow: false,
  isRegisterShow:false,
};

export default state;
